import { v4 as uuidv4 } from 'uuid';

const DEVICE_ID_KEY = 'musein_device_id';

/** 获取（或初始化）持久化的设备 ID */
export function getDeviceId(): string {
  if (typeof window === 'undefined') return 'ssr-device';
  let id = localStorage.getItem(DEVICE_ID_KEY);
  if (!id) {
    id = uuidv4();
    localStorage.setItem(DEVICE_ID_KEY, id);
  }
  return id;
}
